import React from "react";

import { Container } from "react-bootstrap";

import Page from "components/Page/Page";

const config = [
  {
    name: "Aboriginal Artwork",
    moduleComponentName: "AboriginalArtworkBanner",
    rowProps: {},
    moduleProps: { encapsulate: true },
  },
  {
    name: "Noise Insulation",
    moduleComponentName: "SectionHeading",
    rowProps: {
      className: "pt-3 bg-white text-primary",
      noGutters: true,
    },
    moduleProps: {
      heading: {
        priority: 2,
        style: {
          fontWeight: "bold",
        },
        text: "Noise Insulation Program",
      },
      separator: {
        style: {
          width: "100%",
        },
      },
      showClosedSubmissionAlert: false,
    },
    wrapWithContainer: true,
  },
  {
    name: "Noise Insulation",
    id: "Noise Insulation",
    moduleComponentName: "SectionContent",
    columnProps: {
      xs: 12,
      className: "mb-3",
    },
    rowProps: { noGutters: true },
    moduleProps: {
      elementId: "noise-insulation-program",
    },
  },
];

const NoiseInsulationPage = () => {
  return (
    <Container fluid className="page-view">
      <Page config={config} />
    </Container>
  );
};

export default NoiseInsulationPage;
